import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import RolePermissionsMatrix from './RolePermissionsMatrix';
import { PERMISSIONS, mergeRolePermissions } from '../../constants/permissions';
import { useNavigate } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import BackButton from '../../../shared/components/back-button/BackButton';
import { useAuth } from '../../../context/AuthContext';

const TEAM_PATH = '/app/overview/company-management';

const PermissionsManager = () => {
  const { companyData, user } = useAuth();
  const navigate = useNavigate();
  const rolePermissions = mergeRolePermissions(companyData?.rolePermissions);

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        p: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ mb: 3 }}>
        <BackButton
          label="Back to Employees"
          className="back-btn--flush"
          onClick={() => navigate(TEAM_PATH)}
        />
      </Box>

      {(user?.role === 'employee' || user?.role === 'manager') && (
        <Box sx={{ mb: 3 }}>
          {user?.role === 'employee' && (
            <Typography
              variant="body1"
              color="warning.dark"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'warning.light',
                p: 2,
                borderRadius: 2,
                border: '2px solid',
                borderColor: 'warning.main',
                fontWeight: 600,
                fontSize: '1rem',
                boxShadow: 2,
              }}
            >
              <InfoIcon fontSize="medium" />
              Only owners and managers can modify permissions. You can view the current settings but cannot make changes.
            </Typography>
          )}
          {user?.role === 'manager' && (
            <Typography
              variant="body1"
              color="info.dark"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'info.light',
                p: 2,
                borderRadius: 2,
                border: '2px solid',
                borderColor: 'info.main',
                fontWeight: 600,
                fontSize: '1rem',
                boxShadow: 2,
              }}
            >
              <InfoIcon fontSize="medium" />
              You can modify employee permissions. Only owners can modify owner and manager permissions.
            </Typography>
          )}
        </Box>
      )}

      <RolePermissionsMatrix
        permissions={PERMISSIONS}
        rolePermissions={rolePermissions}
      />
    </Box>
  );
};

export default PermissionsManager;
